import Service from "../../services";

const itemModule = {
    namespaced: true,
    state: {
       items: []
    },
    mutations: {
        SET_ITEMS: (state, data) => {
            state.items = data;
        },

    },
    actions: {
        setItems({ commit }) {
            Service.item.getItems().then(res => {
                commit("SET_ITEMS", res);
            });
        },
        getAllItems({commit}) {
            return Service.item.getItems();
        }
    },
    getters: {
        getItems(state) {
            return state.items;
        },
    }
};
export default itemModule;
